import React from 'react';
import * as FiIcons from "react-icons/fi";
import { useTranslation } from 'react-i18next';

import Table from '../../shared/table/Table';
import { Button } from "@chakra-ui/react";

const GTable = ({ data, page, handleDelete }) => {
  const { t } = useTranslation();
  return (
    <Table>
      <thead>
        <tr>
          <th>#</th>
          <th>{t('pages.contacts.name')}</th>
          <th>{t('pages.contacts.email')}</th>
          <th>{t('pages.contacts.message')}</th>
          <th>{t('general.action')}</th>
        </tr>
      </thead>
      <tbody>
        {data.map((el, index) => (
          <tr key={el._id}>
            <td>{((page - 1) * 10) + (index + 1)}</td>
            <td>{el.name}</td>
            <td>{el.email}</td>
            <td>{el.message}</td>
            <td>
              <Button
                bg="transparent" color="red.600" size="xs"
                onClick={() => handleDelete(el)}
              >
                <FiIcons.FiDelete size={20} />
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}

export default GTable